import axios from "axios";
import getBlogCollectionUrl from "@Pages/Blog/utils/getBlogCollectionUrl";
import getCmsRequestUrl from "@Pages/Blog/utils/getCmsRequestUrl";
import getBlogImageUrl from "@Pages/Blog/utils/getBlogImageUrl";
import type { BlogWriter } from "../types";

type CmsWriter = {
  name?: string;
  slug?: string | null;
  role?: string;
  beat?: string | null;
  image?: { url?: string | null } | null;
};

type CmsCountry = {
  slug?: string;
  regionDescription?: string | null;
  isArchived?: boolean | null;
};

export type BlogHomeWriters = {
  writers: BlogWriter[];
  subtitle: string | null;
};

const toWriter = (writer: CmsWriter): BlogWriter | null => {
  if (!writer.name) return null;
  const role = [writer.role, writer.beat].filter(Boolean).join(" · ");
  return {
    name: writer.name,
    role,
    photo: writer.image?.url ? getBlogImageUrl(writer.image.url) : undefined,
    slug: writer.slug ?? undefined,
  };
};

export const fetchBlogHomeWriters = async (): Promise<BlogHomeWriters> => {
  try {
    const { data } = await axios.get<{ data?: CmsWriter[]; subtitle?: string | null }>(
      getCmsRequestUrl("/api/blog-home-writers"),
    );
    return {
      writers: (data?.data || []).map(toWriter).filter((w): w is BlogWriter => !!w),
      subtitle: data?.subtitle?.trim() || null,
    };
  } catch {
    return { writers: [], subtitle: null };
  }
};

export const fetchRegionDescription = async (countrySlug: string): Promise<string | null> => {
  try {
    const { data } = await axios.get<{ docs?: CmsCountry[] }>(
      `${getBlogCollectionUrl(
        "countries",
      )}?where[_status][equals]=published&where[slug][equals]=${encodeURIComponent(
        countrySlug,
      )}&depth=0&limit=1&select[slug]=true&select[regionDescription]=true&select[isArchived]=true`,
    );
    const country = data?.docs?.[0];
    if (!country || country.isArchived === true) return null;
    return country.regionDescription?.trim() || null;
  } catch {
    return null;
  }
};
